import React from "react";
import { useContext } from "react";
import { LanguageContext } from "../utils/contexts";
import { localize } from "../utils/translator";

import { makeStyles } from "@material-ui/core/styles";
import { Grid, ListItem, TextField } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({}));

const CustomTextField = (props) => {
  const classes = useStyles();
  const { language } = useContext(LanguageContext);
  const options = localize(props.options, language) || [];

  return (
    <ListItem button>
      <Grid container spacing={1} alignItems="flex-end">
        <Grid item>{props.children}</Grid>
        <Grid item>
          <TextField
            label={localize(props.name, language)}
            variant="outlined"
            size="small"
            fullWidth
          />
        </Grid>
      </Grid>
    </ListItem>
  );
};

export default CustomTextField;
